/**
 * Self Mode — which records the portal shows: everything the user can reach
 * ("All") or only their own desk ("My desk").
 *
 * It is a request header (`X-Self-Mode`), not a filter, so the backend narrows
 * every self-mode-aware query at once. That is also why the page reloads on a
 * switch: lists, counters and caches live in dozens of stores and refetching
 * all of them in place is not something the app can do reliably.
 */
export const SELF_MODE_SCOPE = {
	all: 'all',
	mine: 'mine',
}

// Read once by the next page load to confirm the switch the user just made.
// Session storage, not the store: it must survive exactly one reload.
export const SELF_MODE_SWITCHED_KEY = 'maestro-self-mode-switched'

/**
 * Whether the stored choice applies to the signed-in user.
 *
 * The choice is kept per browser, so it remembers who made it: otherwise the
 * next person to sign in on the same machine inherits a narrowed portal with no
 * idea why. A choice saved before the owner was recorded (`ownerId` empty), or
 * read before the profile has loaded, still applies — dropping it would widen
 * the portal behind the user's back, which is the very surprise this avoids.
 */
export const isSelfModeActive = ({ enabled, ownerId } = {}, profileId) => Boolean(enabled) && (ownerId == null || profileId == null || ownerId === profileId)
